export default class Usuario{
	 id = 0;
	 email = "";
	 permissoes = "";
	 dataCadastro = "";
	 nome = "";
     razaoSocial = "";
	 cnpj = "";
	 cpf = "";
	 telefone = ""
	 tipoEspecifico = ""
	 codigo = ""
	 funcionarioPrimeseg = false;
}



// WEBPACK FOOTER //
// ./src/model/Usuario.js